import { CompanyFinancialsFilter } from '../interfaces/CompanyFinancialsFilter';
import { CompanyFinancialsTermFilterName } from '../enums/CompanyFinancialsTermFilterName';
import { CompanyFinancialsLocationFilterName } from '../enums/CompanyFinancialsLocationFilterName';

export const initialFilters: CompanyFinancialsFilter = {
  term: CompanyFinancialsTermFilterName.Annual,
  location: CompanyFinancialsLocationFilterName.UsGrid,
};
